<template>
  <div class="container">
    <h1>
      {{label}}book
      <router-link class="btn btn-success btn-sm pull-right" :to="`/spells/new`">
        New
      </router-link>
    </h1>
    <hr>
    <h6 class="text-right stock"><span @click="hideStock = !hideStock" class="include-stock c5">Hide Stock {{label}}s </span> <ez-switch v-model="hideStock"></ez-switch></h6>

    <h5 class="text-center">
      <span v-for="itemType in itemTypes" :key="itemType"  v-if="itemsSorted(itemType).length > 0">
        <router-link :to="`#list-${itemType}`">{{itemType.toUpperCase()}}</router-link> <span v-if="itemType !== itemTypes[itemTypes.length-1]" class="c3"> / </span> 
      </span>
    </h5>
    <div v-for="alpha in alphas" :key="alpha">
      <div class="indent section" v-if="itemsSorted(alpha).length > 0">
        <h3 :name="alpha.toUpperCase()" :id="`list-${alpha}`">{{ alpha.toUpperCase() }}</h3>
        <div class="indent">
          <div v-for="item in itemsSorted(alpha)" :key="item._id">
            <strong :id="`${$embers.slugify(item.name)}`">
              <router-link :to="`/spells/${item._id}`">{{item.name || label}}</router-link>
              <span v-if="item.school" class="subheader"> [{{item.school}}] </span>
              <span v-if="item.stock && item.summary"> - </span>
              <span v-if="item.stock === false"> <i class="fa fa-user-circle" aria-hidden="true"></i></span>
            </strong>
            {{item.summary}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import EzSwitch from "../shared/_VueEzSwitch.vue";

export default {
  name: "spell-index",
  components: {
    EzSwitch
  },
  data() {
    return {
      alphas: [
        // '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z"
      ],
      hideStock: false
    };
  },
  watch: {
    $route: "getData"
  },
  created() {
    this.getData();
    this.$embers.pageData("Spellbook");
  },
  computed: {
    ...mapState({
      items: state => state.spells.all,
      ruleset: state => state.session.user.settings.ruleset
    }),
    itemTypes() {
      return this.alphas.filter(x => this.itemsSorted(x).length > 0);
    },
    label() {
      return ["Savage Worlds"].includes(this.ruleset) ? "Power" : "Spell";
    }
  },
  methods: {
    ...mapActions({
      spellsAll: "spells/all"
    }),
    itemsSorted(alpha) {
      let items;
      if (this.hideStock) {
        items = this.items.filter(
          x =>
            x.ruleset === this.ruleset &&
            x.name &&
            x.name.toLowerCase().startsWith(alpha) &&
            x.stock !== true
        );
      } else {
        items = this.items.filter(
          x =>
            x.ruleset === this.ruleset &&
            x.name &&
            x.name.toLowerCase().startsWith(alpha)
        );
      }

      return items.sort(function(a, b) {
        let nameA = a.name ? a.name.toUpperCase() : ""; // ignore upper and lowercase
        let nameB = b.name ? b.name.toUpperCase() : ""; // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
    },
    async getData() {
      try {
        this.spellsAll({ params: `ruleset=${this.ruleset}&sort=name` });
        this.$embers.pageData("Spells");
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  margin-bottom: 2em;
}
.fa {
  display: inherit;
}
.stock {
  margin-top: -1rem;
  margin-bottom: 0;
  line-height: 0.5em;
  font-size: 0.875rem;
}
.include-stock {
  cursor: pointer;
  line-height: 1.7em;
  vertical-align: top;
}
</style>
